/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : typeApprovalAPI.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author Abdul Rahim M-abdul@au79consulting.com
 * @date 12-08-2024
 * @description  Type Approval API documentation Apis
 */

import actionType from "../actionTypes";
const typeApprovalAPI = {
  get_add_intersection: {
    api_name: "/ACM/intersections/details",
    https_method: "POST",
    action_type: actionType.GET_CREATE_INTERSECTIONS,
    description:
      "View the intersection details for the software module and legal requirements",
  },
  get_add_intersection_new: {
    api_name: "/ACM/intersections/details",
    https_method: "POST",
    action_type: "",
    description: "",
  },
  add_intersection: {
    api_name: "/ACM/intersections/create",
    https_method: "POST",
    action_type: actionType.CREATE_INTERSECTIONS,
    description:
      "Link the software modules with the legal requirements and create the tickets for the intersection,",
  },
  add_ee_intersection: {
    api_name: "/ACM/intersections/ee_create",
    https_method: "POST",
    action_type: "",
    description:
      "Link the ee component with the legal requirements and create the tickets for the intersection,",
  },
  get_tickets: {
    api_name: "/ACM/intersections/tickets",
    https_method: "GET",
    action_type: actionType.GET_TICKETS,
    description: "Get Tickets",
  },
  update_project_status_tickets: {
    api_name: "/ACM/intersections/tickets/status",
    https_method: "PUT",
    action_type: actionType.UPDATE_PROJECT_STATUS_TICKETS,
    description: "Update Project Status",
  },
  re_create_tickets: {
    api_name: "/ACM/intersections/re-create",
    https_method: "POST",
    action_type: actionType.RE_CREATE_TICKETS,
    description: "Re-Create Tickets",
  },
  delete_tickets: {
    api_name: "/ACM/intersections/delete",
    https_method: "PUT",
    action_type: actionType.DELETE_DRAFT_TICKETS,
    description: "Delete Draft Tickets",
  },
  get_ee_add_intersection: {
    api_name: "/ACM/intersections/ee_details",
    https_method: "POST",
    action_type: "",
    description: "",
  },
  get_vehicle_add_intersection: {
    api_name: "/ACM/intersections/vehicle_create",
    https_method: "POST",
    action_type: "",
    description: "",
  },
  get_vehicle_systems_add_intersection: {
    api_name: "/ACM/intersections/vehicle_systems_create",
    https_method: "POST",
    action_type: "",
    description: "",
  },
  get_vs_vc_add_intersection: {
    api_name: "/ACM/intersections/vehicle_details",
    https_method: "POST",
    action_type: "",
    description: "",
  },
  get_default_templates: {
    api_name: "/SCM/templates/intersections/details",
    https_method: "GET",
    action_type: "",
    description: "",
  },
  get_user_dynamic_forms: {
    api_name: "/ACM/intersections/user-dynamic-forms",
    https_method: "GET",
    action_type: "",
    description: "",
  },
  get_dynamic_form_logs: {
    api_name: "/ACM/intersections/dynamic-form/logs",
    https_method: "GET",
    action_type: "",
    description: "",
  },
  update_dynamic_form: {
    api_name: "/ACM/intersections/dynamic-form/update",
    https_method: "PUT",
    action_type: "",
    description: "",
  },
  unlink_legal_from_ee: {
    api_name: "/ACM/intersections/ee/un-link",
    https_method: "PUT",
    action_type: "",
    description: "",
  },
  unlink_legal_from_swm: {
    api_name: "/ACM/intersections/un-link",
    https_method: "PUT",
    action_type: "",
    description: "",
  },
  get_tickets_trace_track_details: {
    api_name: "/ACM/intersections/tickets-by-dimensions",
    https_method: "GET",
    action_type: "",
    description: "",
  },
  recreate_parent_tickets: {
    api_name: "/RCS/intersection/recreate",
    https_method: "POST",
    action_type: "",
    description: "",
  },
};

export default typeApprovalAPI;
